import Joi from 'joi';
import PropTypes from 'prop-types';
import Form from '../../common/form';

class UTInspectionOverviewForm extends Form {
	state = {
		data: {
			inspectionStd: '',
			corrosionAllowance: '',
			ndeTechnique: '',
			equipment: '',
			probe: '',
			amplitudeLinearityCheck: '',
			screenHeightLinearityCheck: '',
			calibrationBlk: '',
			refStd: '',
			serialNo: '',
			scanningLevel: '',
			couplant: '',
			remarks: '',
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		inspectionStd: Joi.string().min(3).required().label('Inspection Standard'),
		corrosionAllowance: Joi.string()
			.min(3)
			.required()
			.label('Corrosion Allowance'),
		ndeTechnique: Joi.string().min(3).required().label('NDE Technique'),
		equipment: Joi.string().min(3).required().label('Equipment'),
		probe: Joi.string().min(3).required().label('Probe'),
		amplitudeLinearityCheck: Joi.string()
			.required()
			.label('Amplitude Linearity Check'),
		screenHeightLinearityCheck: Joi.string()
			.required()
			.label('Screen Height Linearity Check'),
		calibrationBlk: Joi.string().min(3).required().label('Calibration BLK'),
		refStd: Joi.string().min(3).required().label('Ref Std'),
		serialNo: Joi.string().min(3).required().label('Serial Number'),
		scanningLevel: Joi.string().min(3).required().label('Scanning Level'),
		couplant: Joi.string().min(3).required().label('Couplant'),
		remarks: Joi.string().required().label('Remarks'),
	};

	static propTypes = {
		onProceed: PropTypes.func,
	};

	doSubmit = (): void => {
		const props: any = this.props;
		props.onProceed(this.state.data);

		this.setState({
			data: {
				inspectionStd: '',
				corrosionAllowance: '',
				ndeTechnique: '',
				equipment: '',
				probe: '',
				amplitudeLinearityCheck: '',
				screenHeightLinearityCheck: '',
				calibrationBlk: '',
				refStd: '',
				serialNo: '',
				scanningLevel: '',
				couplant: '',
				remarks: '',
			},
		});
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'inspectionStd',
							label: 'Inspection Standard',
							placeholder: 'Enter Inspection Standard',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'corrosionAllowance',
							label: 'Corrosion Allowance',
							placeholder: 'Enter Corrosion Allowance',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'ndeTechnique',
							label: 'NDE Technique',
							placeholder: 'Enter NDE Technique',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'equipment',
							label: 'Equipment',
							placeholder: 'e.g. Enter Equipment',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'couplant',
							placeholder: 'Enter Couplant',
							label: 'Couplant',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'probe',
							label: 'Probe',
							placeholder: 'Enter Probe',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'calibrationBlk',
							label: 'Calibration Blk',
							placeholder: 'Enter Calibration Blk',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'amplitudeLinearityCheck',
							label: 'Amplitude Linearity Check',
							placeholder: 'Enter Amplitude Linearity Check',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'screenHeightLinearityCheck',
							label: 'Screen Height Linearity Check',
							placeholder: 'Enter Screen Height Linearity Check',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'refStd',
							label: 'Ref Standard',
							placeholder: 'Enter Ref Standard',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'serialNo',
							label: 'Serial Number',
							placeholder: 'Enter Serial Number',
						})}
					</div>

					<div className="col">
						{this.renderInput({
							type: 'text',
							name: 'scanningLevel',
							label: 'Scanning Level',
							placeholder: 'Enter Scanning Level',
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				{this.renderTextArea({
					name: 'remarks',
					label: 'Remarks',
					placeholder: 'Enter Remarks',
					rows: '6',
				})}

				{this.renderButton('Submit Overview')}
			</form>
		);
	}
}

export default UTInspectionOverviewForm;
